import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appClickableDirective]',
  standalone: true
})
export class ClickableDirective {

  constructor() { }

  @Output() appClickableDirective = new EventEmitter<Event>();
  @HostBinding('attr.role') role = 'button';
  @HostBinding('attr.tabindex') tabindex = 0;
  @HostListener('click', ['$event'])
  @HostListener('keydown.enter', ['$event'])
  @HostListener('keydown.space', ['$event'])
  onInteraction(event: Event) {
    if (event instanceof KeyboardEvent) {
      event.preventDefault();
    }
    this.appClickableDirective.emit(event);
  }

}
